import MasterShopFaceRegistrationForm from './MasterShopFaceRegistrationForm';

export default MasterShopFaceRegistrationForm;
